<template>
    <div class="row charts">
        <div class="col-xs-12 col-sm-6">
            <strong>Energifördelning</strong>
            <canvas id="recipe-chart--energy" ref="energychart"></canvas>
        </div>
        <div class="col-xs-12 col-sm-6">
            <strong>Fett</strong>
            <canvas id="recipe-chart--fat" ref="fatchart"></canvas>
        </div>
        <div class="col-xs-12 col-sm-6">
            <strong>Kalorier</strong>
            <canvas id="recipe-chart--calories" ref="calorieschart"></canvas>
        </div>
        <div class="col-xs-12 col-sm-6">
            <strong>Övriga ämnen</strong>
            <canvas id="recipe-chart--other" ref="otherchart"></canvas>
        </div>
        <div class="col-xs-12">
            <strong>Vitaminer och mineraler</strong>
            <canvas id="recipe-chart--mineral" ref="vitaminsmineralschart"></canvas>
        </div>
    </div>
</template>

<script>

import {
    Chart,
    PieController,
    BarController,
    LineController,
    ArcElement,
    BarElement,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Legend,
    Tooltip
} from 'chart.js';

Chart.register(
    PieController,
    BarController,
    LineController,
    ArcElement,
    BarElement,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Legend,
    Tooltip
);



export default {
    props: ['data'],

    data() {
        return {
            lightGreen: 'rgba(206, 226, 149, 1)',
            green: 'rgba(149, 193, 33, 1)',
            orange: 'rgba(245, 130, 51, 1)',
            gray: 'rgba(242, 242, 243, 1)',
            magenta: 'rgba(220, 45, 131, 1)',
            color1: 'rgba(247,179,179, 1)',
            color2: 'rgba(236,190,19, 1)',
            bgColors: [
                'rgba(206, 226, 149, 1)',
                'rgba(149, 193, 33, 1)',
                'rgba(242, 242, 243, 1)',
                'rgba(205, 205, 205, 1)'
            ]
        };
    },

    mounted() {
        this.energyChart();
        this.fatChart();
        this.caloriesChart();
        this.mineralsVitaminsChart();
        this.otherChart();
    },

    methods: {
        isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        },

        round(num) {
            if (!this.isFloat(num)) {
                return num;
            }

            return num.toFixed(1);
        },

        fatChart() {
            const fatChart = this.data.fat.values.map((item) => {
                return this.round(item);
            });

            const myChart = new Chart(this.$refs.fatchart.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: this.data.fat.labels,
                    datasets: [
                        {
                            label: 'gram',
                            data: fatChart,
                            backgroundColor: this.lightGreen,
                            borderColor: this.borderColors,
                            borderWidth: 0
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: { display: false }
                    },
                    scales: {
                        y: {
                            min: 0,
                            title: {
                                display: true,
                                text: 'gram'
                            }
                        }
                    }
                }
            });
        },

        energyChart() {
            const energyChart = this.data.energy.values.map((item) => {
                return this.round(item);
            });

            const myChart = new Chart(this.$refs.energychart.getContext('2d'), {
                type: 'pie',
                data: {
                    labels: this.data.energy.labels,
                    datasets: [
                        {
                            label: 'gram',
                            data: energyChart,
                            backgroundColor: this.bgColors,
                            borderColor: this.borderColors,
                            borderWidth: 1
                        }
                    ]
                }
            });
        },

        caloriesChart() {
            const caloriesChart = this.data.calories.values.map((item) => {
                return this.round(item);
            });

            const myChart = new Chart(this.$refs.calorieschart.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: this.data.calories.labels,
                    datasets: [
                        {
                            label: 'Kcal',
                            data: caloriesChart,
                            backgroundColor: this.bgColors,
                            borderColor: this.borderColors,
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: { display: false }
                    },
                    scales: {
                        y: {
                            min: 0,
                            title: {
                                display: true,
                                text: 'gram'
                            }
                        }
                    }
                }
            });
        },

        mineralsVitaminsChart() {
            const data = this.data;

            const mineralsVitaminsChart = this.data.minerals_vitamins.percentage.map((item) => {
                return this.round(item);
            });

            const myChart = new Chart(this.$refs.vitaminsmineralschart.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: this.data.minerals_vitamins.labels,
                    datasets: [
                        {
                            data: mineralsVitaminsChart,
                            pointRadius: 0,
                            hitRadius: 5,
                            label: 'RDI, ditt rekommenderade dagliga intag',
                            backgroundColor: this.lightGreen
                        },
                        {
                            data: [
                                100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
                                100, 100, 100, 100, 100
                            ],
                            pointRadius: 0,
                            type: 'line',
                            backgroundColor: this.green,
                            borderColor: this.green,
                            fill: false
                        }
                    ]
                },
                options: {

                    scales: {
                        x: { ticks: { autoSkip: false } },
                        y: {
                            suggestedMax: 160,
                            min: 0,
                            title: { display: true, text: 'RDI, ditt rekommenderade dagliga intag' }
                        }
                    },

                    plugins: {
                        legend: {
                            display: false
                        },

                        tooltips: {
                            mode: 'index',
                            callbacks: {
                                label: function (tooltipItem, chart) {
                                    const value = data.minerals_vitamins.values[tooltipItem.index].value;
                                    const rdi = data.minerals_vitamins.values[tooltipItem.index].rdi;

                                    return tooltipItem.datasetIndex == 1
                                        ? 'Ditt värde: ' + value + ' / RDI: ' + rdi
                                        : '';
                                }
                            },
                            footerFontStyle: 'normal',
                            displayColors: false
                        }
                    }

                }
            });
        },

        otherChart() {
            const otherChart = this.data.other.values.map((item) => {
                return this.round(item);
            });

            const myChart = new Chart(this.$refs.otherchart.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: this.data.other.labels,
                    datasets: [
                        {
                            label: 'gram',
                            data: otherChart,
                            backgroundColor: this.bgColors,
                            borderColor: this.borderColors,
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: { display: false }
                    },
                    scales: {
                        y: {
                            min: 0,
                            title: {
                                display: true,
                                text: 'gram'
                            }
                        }
                    }


                }
            });
        }
    }
};
</script>
